import styles from './Tenants.module.css';
// import '../../resources/css/admin_style.css';
import React, {useContext, useEffect, useState} from "react";
import {ModalContext} from "../../utils/modal/ModalProvider";
import { IAM_SERVER_TENANT_USER} from "../../utils/Config";
import axios from "../../utils/api/axios";  
import DetailModal from "../../utils/modal/DetailModal";
import {TenantDetailModal} from "./modal/TenantDetailModal";
import {TenantsRegisterModal} from "./modal/TenantsRegisterModal";
import DatePicker from "react-datepicker";
import { ko } from "date-fns/locale/ko";
import dayjs from "dayjs";
import { AuthContext } from '../../utils/contextapi/AuthProvider';
import TenantsTable from './component/TenantsTable';
import { useModal, useInnocodeLoadingOverlay } from '@intsoft/innocode-core';

export const ModalEnum = {
    //기기 관리 Modal Enum
    REGISTER: 'register_one_button',
    DETAIL: 'modify_and_delete_two_button'
}

/**
 * 테넌트 관리 화면
 * @param isMobile
 * @param setMovePage
 * @returns {JSX.Element}
 * @constructor
 */
function Tenants({isMobile, setMovePage}) {
    const { showInnocodeModal } = useModal();
    const { show: showLoading, hide: hideLoading } = useInnocodeLoadingOverlay();

    const {openModal} = useContext(ModalContext);
    const {role, user} = useContext(AuthContext);

    const [isMobileWindow, setIsMobileWindow] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileWindow(window.innerWidth < 768); // 모바일 기준 너비
        };
        handleResize(); // 초기값
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    //검색 조건
    const [searchValue, setSearchValue] = useState('');

    //테이블 데이터
    const [cellData, setCellData] = useState([]);
    const [page, setPage] = useState(0);
    const listSize = 10; // 한 페이지당 보여줄 항목 수
    const [totalCount, setTotalCount] = useState(0);

    // 정렬 Custom
    const [sortModel, setSortModel] = React.useState({
        field: "createdDate",   // 현재 정렬 기준값
        sort: "desc",   // (asc: 오름차순, desc: 내림차순)
    });

    useEffect(() => {
        // setMovePage("tenants");
     
    }, []);

    // page 또는 정렬 조건이 바뀔 때마다 Reloading
    useEffect(() => {
        fetchData();
    }, [page]);

    // 데이터 테이블 조회 API
    const fetchData = async () => {
        showLoading();

        try {
            const userProfileList = user.sub_profile || []; // 현재 사용자의 프로필 목록

            const allProfileIds = userProfileList.map(profile => profile.profile_id); // 모든 프로필 ID 추출

            if (allProfileIds.length === 0) {
                // 사용자가 어떤 프로필에도 속해있지 않으면 빈 목록으로 처리
                setCellData([]);
                setTotalCount(0);
                hideLoading();
                return;
            }

            // ------------------- 1. 사용자의 모든 프로필이 소속된 테넌트 목록 조회 -------------------
            const memberOfTenantRequests = allProfileIds.map(profileId =>
                axios.get(`${IAM_SERVER_TENANT_USER}/get/${profileId}/tenants`)
            );
            
            
            const responses = await Promise.allSettled(memberOfTenantRequests);

            const allMemberOfTenants = responses
                .filter(res => res.status === "fulfilled" && Array.isArray(res.value.data.data))
                .flatMap(res => res.value.data.data);

            // ------------------- 2. 테넌트 목록 중복 제거 -------------------
            const tenantsMap = new Map();
            allMemberOfTenants.forEach(tenant => {
                tenantsMap.set(tenant.tenantId, tenant);
            });
            const uniqueTenants = Array.from(tenantsMap.values());

            if (uniqueTenants.length === 0) {
                // 소속된 테넌트가 없는 경우
                setCellData([]);
                setTotalCount(0);
                hideLoading();
                return;
            }

            // ------------------- 3. 각 테넌트에 대한 현재 사용자 권한 조회 및 추가 -------------------
            // 이제 /get/tenant API를 사용하여 각 테넌트에 대한 권한 정보를 가져옵니다.
            const permissionRequests = uniqueTenants.map(tenant => 
                axios.post(`${IAM_SERVER_TENANT_USER}/get/tenant`, {
                    tenantId: tenant.tenantId,
                    profileIds: allProfileIds // 사용자의 모든 프로필 ID 목록 전달
                })
            );
            
            const permissionResponses = await Promise.allSettled(permissionRequests);
            
            // 테넌트 ID를 키로, 권한 정보를 값으로 하는 맵 생성
            const permissionsMap = new Map();
            permissionResponses
                .filter(res => res.status === "fulfilled" && Array.isArray(res.value.data.data))
                .flatMap(res => res.value.data.data)
                .forEach(permission => {
                    // 한 테넌트에 여러 프로필이 속할 수 있으므로, 가장 높은 권한을 가진 프로필의 정보를 저장
                    // (예: OWNER > MANAGER > USER)
                    const existingPermission = permissionsMap.get(permission.tenantId);
                    if (!existingPermission || getRolePriority(permission.tenantType) > getRolePriority(existingPermission.tenantType)) {
                        permissionsMap.set(permission.tenantId, permission);
                    }
                });

            // ------------------- 4. 최종 데이터 병합 -------------------
            const finalDataWithPermissions = uniqueTenants.map(tenant => {
                const userPermission = permissionsMap.get(tenant.tenantId);
                return {
                    ...tenant,
                    // ✅ currentUserPermission 필드에 현재 사용자의 권한 정보 추가
                    currentUserPermission: userPermission || null 
                };
            }).filter(tenant => tenant.status !== 'pending' && tenant.status !== 'reject'); // pending, reject 상태 제외

            // ------------------- 5. 클라이언트 측 페이징 -------------------
            const total = finalDataWithPermissions.length;

            setTotalCount(total);
            setCellData(finalDataWithPermissions)

        } catch (error) {
            console.error(error);
        } finally {
            hideLoading();
        }
    }

      // 권한 우선순위를 반환하는 헬퍼 함수
    const getRolePriority = (tenantType) => {
        switch (tenantType) {
            case 'OWNER': return 3;
            case 'MANAGER': return 2;
            case 'USER': return 1;
            default: return 0;
        }
    };

    //검색 조회
    const handleSearch = async () => {
        setPage(0);
        fetchData();
    }

    // 서비스 등록 모달 핸들러
    const handleRegisterService = () => {
        const modalContent = <TenantsRegisterModal update={fetchData}/>
        const modalOption = {modalTitle: '테넌트 등록'}
        openModal(<DetailModal content={modalContent} option={modalOption} />) 

    }

    // 서비스 상세정보 모달 핸들러
    const handleDetailInfo = (id, tenantUserId, currentTenantType) => {
        const modalContent = <TenantDetailModal id={id} tenantUserId={tenantUserId} currentTenantType={currentTenantType} update={fetchData}/>
        const modalOption = {modalTitle: '테넌트 정보'}
        openModal(<DetailModal content={modalContent} option={modalOption} />)
        
    };

    const handleSortModal = () => {
        if (sortModel.sort === "asc") {
            setSortModel((prevState) => ({
                ...prevState,
                sort: "desc"
            }));
        } else {
            setSortModel((prevState) => ({
                ...prevState,
                sort: "asc"
            }));
        }
    }

    const handleNextPage = () => {
        setPage((prevPage) => {
            const newPage = prevPage + 1;
            return newPage;
        });
    };

    const handlePrevPage = () => {
        setPage((prevPage) => {
            const newPage = Math.max(prevPage - 1, 0);
            return newPage;
        });
    };

    return (
        <div className={"content-wrapper"}>
            <h3>테넌트 관리</h3> 
            <div className={styles.rightCont__cont__tableWrap} style={{ flex: "1" }}>
                <div className={styles.permissionPanel}>
                    <TenantsTable
                        datas={cellData}
                        onAddUser={handleRegisterService}
                        detailUser={handleDetailInfo}
                        onPrevPage={handlePrevPage}
                        onNextPage={handleNextPage}
                        disablePrev={page === 0}
                        disableNext={(page + 1) * listSize >= totalCount}
                        pageNumber={page}
                        totalCount={totalCount}
                        listSize={listSize}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        onSearch={handleSearch}
                        isMobileWindow={isMobileWindow}
                    />
                </div>
            </div>
        </div>
    )
}

export default Tenants;
